import React, { useState, useEffect } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { API_URL, ENDPOINTS, getData } from '../../constants/api';

// ==========================================
// API Function (Predefined as requested)
// ==========================================
 

export default function OfficePosters() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function loadData() {
            try {
                // Pass the endpoint/URL to the predefined function
                const url = `${API_URL}/${ENDPOINTS.SYS}/getlink/ktc_general-report`;
                const result = await getData(url);
                console.log('result:',result.report)
                setData(result.report);
            } catch (err) {
                setError('Failed to load office data.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        }
        loadData();
    }, []);

    if (loading) return <div className="text-center p-12 text-slate-400">Loading posters...</div>;
    if (error) return <div className="text-center p-12 text-red-500">{error}</div>;
    if (!data) return null;

    return (
        <div className="bg-neutral-700 min-h-screen py-10 print:bg-white print:py-0">
            {/* Print Styles Sheet injected inline for convenience */}
            <style dangerouslySetInnerHTML={{ __html: `
                @page {
                    size: A4 portrait;
                    margin: 0;
                }
                @media print {
                    body {
                        background: white;
                    }
                    .a4-page {
                        margin: 0 !important;
                        box-shadow: none !important;
                        width: 100% !important;
                        height: 100vh !important;
                        page-break-after: always;
                        break-after: page;
                    }
                }
            ` }} />

            {/* Container mapping through offices to generate an A4 page per office */}
            {data.offices.map((office) => {
                const targetUrl = `https://pal.uni.so/complaint/${office.id}`;

                return (
                    <div 
                        key={office.id} 
                        className="a4-page text-center bg-white mx-auto my-10 box-border flex flex-col justify-between relative shadow-2xl print:shadow-none"
                        style={{
                            width: '210mm',
                            height: '297mm',
                            padding: '25mm 20mm',
                            pageBreakAfter: 'always',
                            breakAfter: 'page'
                        }}
                    >
                        {/* Top Section: University Branding */}
                        <div>
                            <div className="inline-flex items-center justify-center w-28 h-28 p-2 mb-4">
                                <img 
                                    src={data.logoUrl} 
                                    alt={`${data.university} Logo`} 
                                    className="max-h-full max-w-full object-contain" 
                                />
                            </div>
                            <h1 className="text-xl font-bold tracking-widest text-slate-500 uppercase">
                                {data.university}
                            </h1>
                        </div>

                        {/* Middle Section: Office & Instructions */}
                        <div className="my-auto space-y-8">
                            {/* Office Details Box */}
                            <div className="bg-slate-50 border-2 border-blue-950/20 rounded-3xl p-8 max-w-lg mx-auto shadow-sm">
                                <span className="inline-block bg-blue-100 text-blue-900 text-sm font-bold px-4 py-1.5 rounded-full mb-3">
                                    Office ID: {office.id}
                                </span>
                                <h2 className="text-4xl font-black text-blue-950 tracking-tight">
                                    {office.name}
                                </h2>
                            </div>

                            {/* Call to Action */}
                            <div className="max-w-md mx-auto space-y-2">
                                <h3 className="text-2xl font-bold text-slate-900">Have a Complaint or Inquiry?</h3>
                                <p className="text-base text-slate-600 leading-relaxed">
                                    Scan the QR code below using your smartphone camera to access our digital complaint submission form and track your request instantly.
                                </p>
                            </div>

                            {/* Large QR Code Box */}
                            <div className="flex justify-center">
                                <div className="bg-white p-6 rounded-3xl border-4 border-blue-900 shadow-xl inline-block">
                                    <QRCodeCanvas 
                                        value={targetUrl}
                                        size={220}
                                        level="H"
                                        color={{
                                            dark: "#1e3a8a",
                                            light: "#ffffff"
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Footer Section */}
                        <div className="border-t border-slate-200 pt-6 text-sm text-slate-400 font-medium">
                            Office of Student Affairs &bull; Quality Assurance Unit &bull; Official Campus Portal
                        </div>
                    </div>
                );
            })}
        </div>
    );
}